'use strict';

var assign = require('./assign')
  , value  = require('./valid-value');

module.exports = function (obj) {
	var copy = Object(value(obj));
	if (copy !== obj) return copy;
	return assign({}, obj);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/object/copy.js
 ** module id = 174
 ** module chunks = 0
 **/